import IMask from 'imask';

const Forms = () => {
    const formFields = document.querySelectorAll(
        'input:not([name="s"]), select:not([name="setor"]):not([name="estagio"]), textarea'
    );
    let recaptchaLoaded = false;

    const loadReCaptcha = () => {
        if (recaptchaLoaded) return;

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${appConfig.recaptchaSiteKey}`;
        script.onload = initializeReCaptcha;
        document.head.appendChild(script);
        recaptchaLoaded = true;
    };

    const initializeReCaptcha = () => {
        grecaptcha.ready(() => {
            grecaptcha.execute(appConfig.recaptchaSiteKey, { action: 'homepage' })
                .then(updateReCaptchaToken);
        });
    };

    const updateReCaptchaToken = (token) => {
        const inputElement = document.querySelectorAll("input[name='recaptcha_token']");
        inputElement.forEach(el => {
            if (el) el.value = token;
        })
    };

    formFields.forEach(field =>
        field.addEventListener('focus', loadReCaptcha, { once: false })
    );

    const inputTelefone = document.querySelectorAll('input[name="telefone"]');
    if (inputTelefone) {
        inputTelefone.forEach(input => {
            IMask(input, { mask: '(00) 00000-0000' });
        })
    }
};

export default Forms;

Forms();

window.reloadCaptcha = (action, fieldName = 'recaptcha_token', callback = null) => {
    grecaptcha.ready(() => {
        grecaptcha.execute(appConfig.recaptchaSiteKey, { action })
            .then(token => {
                const inputElement = document.querySelectorAll(`input[name='${fieldName}']`);
                inputElement.forEach(el => {
                    if (el) el.value = token;
                    if (callback) callback();
                })
            });
    });
};
